export default "__VITE_ASSET__Dkqisyrj__"